"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YELLOW_OPAQUE_LIGHT = exports.YELLOW_OPAQUE_DARK = exports.YELLOW = exports.WHITE_OPAQUE = exports.WHITE = exports.VAMPIRE_BLACK = exports.SYSTEM_PRODUCTION_OPAQUE = exports.SYSTEM_PRODUCTION = exports.SUNRUN_ORANGE_OPAQUE = exports.SUNRUN_ORANGE = exports.SOLAR_OPAQUE = exports.SOLAR = exports.SELF_CONSUMPTION = exports.RED_OPAQUE = exports.RED = exports.PURPLE = exports.PINK = exports.PEER_V2_OPAQUE = exports.PEER_V2 = exports.PEER_ADJ = exports.PEA_GREEN = exports.ORANGE = exports.OLIVE = exports.NAVY = exports.MINE_SHAFT = exports.METER_OPAQUE = exports.METER = exports.LINE_ORANGE = exports.LIGHT_GREEN = exports.LIGHT_BLUE_OPAQUE = exports.LIGHT_BLUE = exports.IMPORT_COLOR = exports.GREY_HOVER = exports.GREY = exports.GREEN_OPAQUE_LIGHT = exports.GREEN_OPAQUE_DARK = exports.GREEN = exports.FADED_GREY = exports.FADED_GREEN = exports.EXPORT = exports.ESTIMATED_SOLAR_OVERLAY = exports.ESTIMATED_SOLAR_HOVER = exports.ESTIMATED_PRODUCTION = exports.DOLPHIN_GREY = exports.DARK_SLATE_GREY = exports.DARK_RED = exports.DARK_GREY = exports.DARK_GREEN = exports.CONTRACTED = exports.CONSUMPTION = exports.CHARCOAL = exports.CCC = exports.BURNT_ORANGE = exports.BLUE = exports.BLACK = exports.BILLED = exports.BATTERY_PERCENTAGE = exports.BATTERY_DISCHARGED = exports.BATTERY_CHARGED = void 0;
// BLACK & WHITE
var BLACK = '#000000';
exports.BLACK = BLACK;
var CHARCOAL = '#4A4A4A';
exports.CHARCOAL = CHARCOAL;
var MINE_SHAFT = '#333333';
exports.MINE_SHAFT = MINE_SHAFT;
var VAMPIRE_BLACK = '#080808';
exports.VAMPIRE_BLACK = VAMPIRE_BLACK;
var WHITE = '#FFFFFF';
exports.WHITE = WHITE;
var WHITE_OPAQUE = '#FFFFFF66'; // BLUES

exports.WHITE_OPAQUE = WHITE_OPAQUE;
var BLUE = '#0087FF';
exports.BLUE = BLUE;
var LIGHT_BLUE = '#06A7E0';
exports.LIGHT_BLUE = LIGHT_BLUE;
var LIGHT_BLUE_OPAQUE = '#06A7E0CC';
exports.LIGHT_BLUE_OPAQUE = LIGHT_BLUE_OPAQUE;
var NAVY = '#001A3C'; // GREENS

exports.NAVY = NAVY;
var DARK_GREEN = '#357049';
exports.DARK_GREEN = DARK_GREEN;
var FADED_GREEN = '#bdd3bb';
exports.FADED_GREEN = FADED_GREEN;
var GREEN = '#00B085';
exports.GREEN = GREEN;
var GREEN_OPAQUE_DARK = '#00B085CC';
exports.GREEN_OPAQUE_DARK = GREEN_OPAQUE_DARK;
var GREEN_OPAQUE_LIGHT = '#00B08566';
exports.GREEN_OPAQUE_LIGHT = GREEN_OPAQUE_LIGHT;
var LIGHT_GREEN = '#DEE9DD';
exports.LIGHT_GREEN = LIGHT_GREEN;
var PEA_GREEN = '#78B649';
exports.PEA_GREEN = PEA_GREEN;
var OLIVE = '#8CC16F'; // GREYS

exports.OLIVE = OLIVE;
var CCC = '#CCCCCC';
exports.CCC = CCC;
var DARK_GREY = '#808080';
exports.DARK_GREY = DARK_GREY;
var DARK_SLATE_GREY = '#2f4f4f';
exports.DARK_SLATE_GREY = DARK_SLATE_GREY;
var DOLPHIN_GREY = '#EEEEEE';
exports.DOLPHIN_GREY = DOLPHIN_GREY;
var FADED_GREY = '#B2ADA6';
exports.FADED_GREY = FADED_GREY;
var GREY = '#DEDBD6';
exports.GREY = GREY;
var GREY_HOVER = '#F0EFED'; // ORANGES

exports.GREY_HOVER = GREY_HOVER;
var BURNT_ORANGE = '#EEA331';
exports.BURNT_ORANGE = BURNT_ORANGE;
var ORANGE = '#FFB26D';
exports.ORANGE = ORANGE;
var LINE_ORANGE = '#F7981C';
exports.LINE_ORANGE = LINE_ORANGE;
var SUNRUN_ORANGE = '#E2711D';
exports.SUNRUN_ORANGE = SUNRUN_ORANGE;
var SUNRUN_ORANGE_OPAQUE = '#E2711D99'; // REDS

exports.SUNRUN_ORANGE_OPAQUE = SUNRUN_ORANGE_OPAQUE;
var DARK_RED = '#A5000A';
exports.DARK_RED = DARK_RED;
var RED = '#FF0000';
exports.RED = RED;
var RED_OPAQUE = '#FF000066'; // MISC

exports.RED_OPAQUE = RED_OPAQUE;
var PINK = '#E200C1';
exports.PINK = PINK;
var PURPLE = '#9797F8';
exports.PURPLE = PURPLE;
var YELLOW = '#FFD45C';
exports.YELLOW = YELLOW;
var YELLOW_OPAQUE_DARK = '#FFD45CCC';
exports.YELLOW_OPAQUE_DARK = YELLOW_OPAQUE_DARK;
var YELLOW_OPAQUE_LIGHT = '#FFD45C66';
exports.YELLOW_OPAQUE_LIGHT = YELLOW_OPAQUE_LIGHT;
var BATTERY_CHARGED = GREEN_OPAQUE_DARK;
exports.BATTERY_CHARGED = BATTERY_CHARGED;
var BATTERY_DISCHARGED = GREEN_OPAQUE_LIGHT;
exports.BATTERY_DISCHARGED = BATTERY_DISCHARGED;
var BATTERY_PERCENTAGE = PURPLE;
exports.BATTERY_PERCENTAGE = BATTERY_PERCENTAGE;
var BILLED = PEA_GREEN;
exports.BILLED = BILLED;
var CONSUMPTION = LIGHT_BLUE;
exports.CONSUMPTION = CONSUMPTION;
var CONTRACTED = OLIVE;
exports.CONTRACTED = CONTRACTED;
var ESTIMATED_PRODUCTION = BURNT_ORANGE;
exports.ESTIMATED_PRODUCTION = ESTIMATED_PRODUCTION;
var ESTIMATED_SOLAR_HOVER = YELLOW_OPAQUE_LIGHT;
exports.ESTIMATED_SOLAR_HOVER = ESTIMATED_SOLAR_HOVER;
var ESTIMATED_SOLAR_OVERLAY = WHITE_OPAQUE;
exports.ESTIMATED_SOLAR_OVERLAY = ESTIMATED_SOLAR_OVERLAY;
var EXPORT = NAVY;
exports.EXPORT = EXPORT;
var IMPORT_COLOR = LINE_ORANGE;
exports.IMPORT_COLOR = IMPORT_COLOR;
var METER = SUNRUN_ORANGE;
exports.METER = METER;
var METER_OPAQUE = SUNRUN_ORANGE_OPAQUE;
exports.METER_OPAQUE = METER_OPAQUE;
var PEER_ADJ = PINK;
exports.PEER_ADJ = PEER_ADJ;
var PEER_V2 = RED;
exports.PEER_V2 = PEER_V2;
var PEER_V2_OPAQUE = RED_OPAQUE;
exports.PEER_V2_OPAQUE = PEER_V2_OPAQUE;
var SELF_CONSUMPTION = LIGHT_BLUE_OPAQUE;
exports.SELF_CONSUMPTION = SELF_CONSUMPTION;
var SOLAR = YELLOW;
exports.SOLAR = SOLAR;
var SOLAR_OPAQUE = YELLOW_OPAQUE_DARK;
exports.SOLAR_OPAQUE = SOLAR_OPAQUE;
var SYSTEM_PRODUCTION = SUNRUN_ORANGE;
exports.SYSTEM_PRODUCTION = SYSTEM_PRODUCTION;
var SYSTEM_PRODUCTION_OPAQUE = SUNRUN_ORANGE_OPAQUE;
exports.SYSTEM_PRODUCTION_OPAQUE = SYSTEM_PRODUCTION_OPAQUE;